import React from 'react'
import { CFIcon, CFView } from 'components'
import { COLOR } from 'styles'
import { dispatch } from 'store'

export default props => (
  <CFView hover {...props}>
    <CFIcon
      icon={'plus-circle'}
      color={
        dispatch.restaurant.getStyles().brandColor
          ? dispatch.restaurant.getStyles().brandColor
          : COLOR.brand
      }
      fontSize="24px"
    />
  </CFView>
)
